import { gql } from '@apollo/client';


export const GET_CATEGORY_BY_ID = gql`
  query GetCategoryById($id: ID!) {
    category(id: $id) {
      id
      name
      slug
      icon
      parentCategoryId
      subcategories {
        id
        name
      }
    }
  }
`;
export const GET_ALL_CATEGORIES = gql`
  query GetAllCategories {
    categories {
      id
      name
      slug
      icon
      parentCategoryId
      subcategories {
        id
        name
      }
    }
  }
`;
export const CREATE_SUBCATEGORY = gql`
  mutation CreateSubCategory($input: NewCategoryInput!) {
    createSubCategory(input: $input) {
      id
      name
      slug
      icon
      createdAt
    }
  }
`;

export const CREATE_CATEGORY = gql`
  mutation CreateCategory($input: NewCategory!) {
    createCategory(input: $input) {
      id
      name
      slug
      icon
      parentCategoryId
      createdAt
    }
  }
`;

export const UPDATE_CATEGORY = gql`
  mutation UpdateCategory($id: ID!, $input: UpdateCategoryInput!) {
    updateCategory(id: $id, input: $input) {
      id
      name
      slug
      icon
      parentCategoryId
      updatedAt
    }
  }
`;
export const DELETE_CATEGORY = gql`
  mutation DeleteCategory($id: ID!) {
    deleteCategory(id: $id)
  }
`;

export const GET_FILTERED_PRODUCTS = gql`
  query GetProducts(
    $minPrice: Float!
    $maxPrice: Float!
    $categoryId: ID!
    $inStock: Boolean!
    $limit: Int!
    $offset: Int!
  ) {
    getProducts(
      filters: {
        minPrice: $minPrice
        maxPrice: $maxPrice
        categoryId: $categoryId
        inStock: $inStock
      }
      pagination: { limit: $limit, offset: $offset }
    ) {
      totalCount
      edges {
        node {
          id
          name
          price
          categoryId
          images
          description
          slug
          discountedPrice
        }
        cursor
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;
